import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { closeAllModal, showModal } from "../../../features/modal/modalSlice";
import { useEffect, useState } from "react";
import { useScrollLock } from "../../../hooks/useScrollLock";
import Button from "../../shared/button/Btn";
import styled from "styled-components";
import PageTopTitle from "../../shared/PageTopTitle";
import DateInput from "../../jobList/inputs/DateInput";
import { getAracTypes } from "../../../features/adminSett/adminSettSlice";
import {  clearJobListWithoutGunlukAraclar, devamliAraclarFiltre, getDevamliAracList, multipleCitySelect, multipleCitySelectArray, setSelectedPlateNumber,} from "../../../features/joblist/jobListSlice";
import SelectAracDurumuInput from "../../jobList/queueInputs/SelectAracDurumuInput";
import Iller from "../../../utils/iller";
import bolgeOptions from "../../../utils/yukOptions/bolgeOptions";
import AracNeredeInput from "../../jobList/queueInputs/AracNeredeInput";
import GidebilecekIllerInput from "../../jobList/queueInputs/GidebilecekIllerInput";
import GidebilecekBolgelerInput from "../../jobList/queueInputs/GidebilecekBolgelerInput";
import LocationData from "../../../utils/locationData/locationOptions";
import { handleActiveSelect } from "../../../features/layout/layoutSlice";
import { useRef } from "react";
import locationData from "../../../utils/locationData/locationOptions";
import iller from "../../../utils/iller";
import locationCityList from "../../../utils/locationData/locationCityOptions";

const ModalContainer = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 26;

  .modal {
    width: 900px;
    max-height: 700px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border: 1px solid;
    border-color: ${({ theme }) => theme.mainBorderColor};
    padding-top: 20px;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    overflow: auto;
    .plates {
      display: flex;
      align-items: center;
      p {
        margin-inline: 10px;
      }
    }
    .active-plate {
      color: var(--color-main);
      cursor: pointer;
    }
    .none-plate {
      cursor: pointer;
    }
    .inputs {
      padding: 20px;
      width: 100%;
      .row {
        margin-block: 15px;
      }
      .btn {
        width: 60%;
        margin: 0 auto;
        button {
          padding: 10px;
        }
      }
    }
    .second-form {
      padding: 20px;
      width: 60%;
      .row {
        margin-block: 15px;
      }
      .btn {
        margin: 0 auto;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 15px;
        button {
          padding: 10px;
        }
      }
    }
    .sorgulama {
      padding: 10px;
      width: 60%;
      margin: 0 auto;
      display: flex;
      align-items: center;

      .row-control {
        width: 100%;
        display: flex;
        align-items: center;
        margin-top: 15px;
        .control {
          border: 1px solid var(--color-main);
          color: var(--color-main);
          padding: 10px;
          height: 40px;
          border-radius: 10px;
          margin-left: 15px;
        }
      }
    }
  }
  .width {
    display: flex;
    align-items: center;
    width: 60%;
    margin: 0 auto;
  }
`;

const AddQueueVehicleModal = () => {
  const aracDurumu = [
    {
      id: 1,
      text: "Boşta Hazır",
    },
    {
      id: 2,
      text: "Yük Boşaltıyor",
    },
    {
      id: 3,
      text: "Yolda",
    },
  ];

  const dispatch = useDispatch();
  const location = useLocation();

  const [isFoundData, setIsFoundData] = useState(null);
  const {activeSelect} = useSelector(state => state.layout)

  const { modalLocation } = useSelector((state) => state.modal);
  const { lockScroll, unlockScroll } = useScrollLock();

  const { dailyVehicleList, devamliAracItem, devamliAracList, selectedPlateNumber, devamliAraclarFilterValues} = useSelector((state) => state.jobList);

  const {plakaSearch, phoneNumberSearch, aracTuruValue, kasaTipiValue, isDevamliArac, isMemberOfKamyoon} = devamliAraclarFilterValues

  const { vehicleStatus, vehicleCurrentLocation, timeToWaste, gunlukAracListesiCityCanGos, gunlukAracListesiRegionCanGos } = dailyVehicleList;

  //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);

  useEffect(()=>{
    dispatch(getAracTypes());

    dispatch(devamliAraclarFiltre({plaka:plakaSearch, phoneNumber: phoneNumberSearch, aracTuruValue:aracTuruValue.name, kasaTipiValue:kasaTipiValue.name, isDevamliArac:isDevamliArac.bool, isMemberOfKamyoon:isMemberOfKamyoon.bool}))
  },[plakaSearch, phoneNumberSearch, aracTuruValue, kasaTipiValue, isDevamliArac, isMemberOfKamyoon])

  useEffect(() => {
    const found = devamliAracList?.find((item) => {
      const newNumber = devamliAracItem?.phoneNumber.startsWith("90") ? devamliAracItem.phoneNumber.slice(2) : devamliAracItem?.phoneNumber;
      return newNumber === item?.phoneNumber;
    });
    setIsFoundData(found);
  }, [devamliAracList]);

  const handleSave = () => {
    const found = devamliAracList?.find((item) => {
      const newNumber = devamliAracItem?.phoneNumber.startsWith("90") ? devamliAracItem.phoneNumber.slice(2) : devamliAracItem?.phoneNumber;
      return newNumber === item?.phoneNumber;
    });

    const postDriverData = {
      vehicleStatus: vehicleStatus,
      vehicleCurrentLocation: vehicleCurrentLocation,
      timeToWaste: timeToWaste,
      gunlukAracListesiCityCanGos: gunlukAracListesiCityCanGos,
      gunlukAracListesiRegionCanGos: gunlukAracListesiRegionCanGos,
      devamliAraclarId: found?.id || devamliAracItem?.id,
      plate: selectedPlateNumber?.plate || isFoundData?.devamliAraclarPlakas?.[0]?.plate,
    };
    // dispatch(addDailyList(postDriverData));
    dispatch(clearJobListWithoutGunlukAraclar())
  };

  const bottomRef = useRef(null);

  useEffect(() => {
    if ((activeSelect === 'gunlukAracListesiRegionCanGos' || activeSelect === 'gunlukAracListesiCityCanGos') && bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [activeSelect]);

  useEffect(() => {
    const selectedCities = gunlukAracListesiRegionCanGos.map((item) => {
      return iller.filter((innerItem) => {
        return innerItem.region === item.text
      })
    }).flat(Infinity)
    dispatch(multipleCitySelectArray(selectedCities));
  },[gunlukAracListesiRegionCanGos])

  return (
    <ModalContainer>
      <div className="modal" onClick={(e) =>{ e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
        <PageTopTitle isDiffPage title={"Sıraya Ekle"} />

        <div onClick={(e) =>{ e.stopPropagation(); }} className="second-form">
          <div className="row">
            <SelectAracDurumuInput
              options={aracDurumu}
              inputWidth="100%"
              name="vehicleStatus"
              data={vehicleStatus}
              labelText="Araç Durumu"
              keyData="vehicleStatus"
            />
          </div>
          <div className="row">
            <AracNeredeInput
              options={LocationData}
              inputWidth="100%"
              name="vehicleCurrentLocation"
              data={vehicleCurrentLocation}
              labelText="Araç Nerede"
              keyData="vehicleCurrentLocation"
            />
          </div>
          <div className="row">
            <DateInput
              options={aracDurumu}
              inputWidth="100%"
              name="timeToWaste"
              data={timeToWaste}
              labelText="Boşa Çıkma Zamanı"
              keyData="timeToWaste"
            />
          </div>
          <div className="row">
            <GidebilecekBolgelerInput
              options={bolgeOptions}
              inputWidth="100%"
              name="gunlukAracListesiRegionCanGos"
              data={gunlukAracListesiRegionCanGos}
              labelText="Hangi Bölgelere Gidebileceği"
              keyData="gunlukAracListesiRegionCanGos"
            />
          </div>
          <div className="row">
            <GidebilecekIllerInput
              options={Iller}
              inputWidth="100%"
              name="gunlukAracListesiCityCanGos"
              data={gunlukAracListesiCityCanGos}
              labelText="Hangi İllere Gidebileceği"
              keyData="gunlukAracListesiCityCanGos"
            />
          </div>
          {isFoundData?.devamliAraclarPlakas?.$values?.length > 1 && (
            <div className="row width">
              <p>İşlem Yapacağınız Plakayı Seçiniz:</p>
              <div className="plates">
                {isFoundData?.devamliAraclarPlakas?.$values?.map((item) => (
                  <p className={selectedPlateNumber?.id === item?.id ? "active-plate" : "none-plate"} onClick={() => dispatch(setSelectedPlateNumber(item))}>
                    {item?.plate}
                  </p>
                ))}
              </div>
            </div>
          )}

          <div ref={bottomRef}  className="btn">
            <Button width={"150px"} handleClick={handleSave} color="#E85446">
              Sıraya Ekle
            </Button>
            <Button width={"150px"} handleClick={() => {dispatch(closeAllModal()); dispatch(clearJobListWithoutGunlukAraclar()) }} bgColor="#E85446" color="#fff">
              Kapat
            </Button>
          </div>
        </div>
      </div>
    </ModalContainer>
  );
};

export default AddQueueVehicleModal;
